import {Link, useNavigate, useSearchParams} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {getCommunicationTemplates, saveCustomer, searchCustomers} from "../common/api/WebApi";

import * as pagination from "../common/pagination";
import DataTable from "react-data-table-component";
import {AppContext} from "../../lib/AppContext";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {formatDateNoTz, formatDateTime} from "../common/Utils";
import Loading from "../common/Loading";
import {getCookie, setCookie} from "../common/appCookie";
import ActiveMember from "../common/ActiveMember";
import {CompanyContext} from "../../lib/CompanyContext";
import ExtendedBootyPagination from "../common/extendedBootyPagination";
import MDTypography from "../../components/MDTypography";
import BootyPagination from "../common/bootyPagination";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import ComposeEmailModal from "./ComposeEmailModal";
import {Col, Row} from "react-bootstrap";
import {Button, ButtonGroup} from "@mui/material";
import ManageClientModal from "./ManageClientModal";

export default function ListCustomersResults(props) {

  const [context, setContext] = useContext(AppContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const navigate = useNavigate();

  const [smtpEnabled, setSmtpEnabled] = useState(false);

  const [hiddenColumns, setHiddenColumns] = useState(props?.hiddenColumns || []);
  const [canAddCustomer, setCanAddCustomer] = useState(props?.addCustomer)

  const [addCustomer, setAddCustomer] = useState(false);
  const [savingCustomer, setSavingCustomer] = useState(false);
  const [manageCustomerKey, setManageCustomerKey] = useState(1);

  const handleSaveCustomer = async (customer) => {

    setSavingCustomer(true);

    let result = await saveCustomer(customer);

    setSavingCustomer(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setAddCustomer(false);
      searchCustomersFn();
    }
  }

  useEffect(() => {
    setSmtpEnabled(companyContext?.company?.smtpEnabled);
  }, [companyContext]);

  const [searchParams, setSearchParams] = useSearchParams();
  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);

  const [totalRecords, setTotalRecords] = useState(0);
  const [totalFiltered, setTotalFiltered] = useState(0);
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);

  const [render, setRender] = useState(0);
  const [searchCriteria, setSearchCriteria] = useState(searchParams.get('q') || '');
  const [searchIndex, setSearchIndex] = useState(1);

  const [sortDir, setSortDir] = useState(searchParams.get('sortDir') || (getCookie('CUSTOMERS_SORT_DIR') || 'asc'));
  const [sortOrder, setSortOrder] = useState(searchParams.get('sortOrder') || (getCookie('CUSTOMERS_SORT') || 1));

  const rowsOptions = [10, 50, 100, 500];
  const rowOption = 50;
  const [pageSize, setPageSize] = useState(searchParams.get('pageSize') || getCookie('CUSTOMERS_ROW') || rowOption);

  const [startPage, setStartPage] = useState(searchParams.get('startPage') || 0);
  const [searchDeleted, setSearchDeleted] = useState(searchParams.get('searchDeleted') || false);

  const [searchResults, setSearchResults] = useState([]);
  const [tmpResults, setTmpResults] = useState({});

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggledClearRows, setToggledClearRows] = useState(false);
  const [membershipTabActive, setMembershipTabActive] = useState('all');

  const handleRowSelected = React.useCallback(state => {
    let selected = [];
    for (let j in state.selectedRows) {
      selected.push(state.selectedRows[j].guid)
    }
    setSelectedRows(selected);
  }, []);

  const handleClearRows = () => {
    setToggledClearRows(!toggledClearRows);
  };

  useEffect(() => {
    let result = tmpResults;

    if ((result?.searchIndex + 1) === (getSearchIndex() + 1)) {

      if (result.error) {
        // todo: handle error
      } else {
        setSearchResults(result?.customers.data);
        setTotalRecords(result?.customers.total - result?.customers.recordsFiltered);
        setTotalFiltered(result?.customers.recordsFiltered);
        setLoading(false);
        setFirstLoad(false);
      }
    }
  }, [tmpResults]);

  const FamilyMembers = ({row}) => {
    return (<MDBox>
      {row.familyMembers?.sort((a, b) => a.id > b.id ? 1 : -1).map((m, idx) => {
        return <span key={idx}
                     className={'m-chip'}>{idx === 0 ? '' : ' '}{m.firstName + ' ' + m.lastName}
          {m.dob && <small>&nbsp;({formatDateNoTz(m.dob)})</small>}</span>
      })}
    </MDBox>)
  }

  const hideColumn = (name) => {
    return hiddenColumns.indexOf(name) > 0;
  }

  let _columns = [];
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    _columns = [
      {
        name: <span className='th'>Name</span>,
        id: 1,
        selector: row => row.title,
        cell: row => {
          let link = '/client/' + row.guid;
          return <><ActiveMember client={row}/><Link to={link}
                                                     className="link"> {row.firstName} {row.lastName} </Link></>;
        },
        sortable: true,
      },

      {
        name: <span className='th'>Home Location</span>,
        id: 15,
        omit: hideColumn('organizations') || (companyContext?.company?.orgChart ? false : true),
        selector: row => row.companyName,
        cell: row => {
          return row?.companyName;
        },
        sortable: true,
      },

      {
        name: <span className='th'>Created On</span>,
        id: 2,
        omit: hideColumn('createDate'),
        selector: row => row.title,
        cell: row => {
          return row?.createDate ? formatDateTime(row.createDate) : 'None';
        },
        sortable: true,
      },
      {
        name: <span className='th'>Last Visit</span>,
        id: 3,
        omit: hideColumn('lastVisit'),
        selector: row => row.title,
        cell: row => {
          return row?.lastVisitDate ? formatDateTime(row.lastVisitDate) : 'None';
        },
        sortable: true,
      },
      {
        name: <span className='th'>Email</span>,
        id: 14,
        selector: row => row.email,
        cell: row => {
          return row?.email || '';
        },
        sortable: true,
      },
      {
        name: <span className='th'>Referral</span>,
        id: 12,
        omit: hideColumn('referral'),
        selector: row => (row.referralType?.name?.toUpperCase() || -1),
        cell: row => {
          return row?.referralType?.name || 'None';
        },
        sortable: true,
      },
      {
        name: <span className='th'>Flagged</span>,
        id: 13,
        omit: hideColumn('referral') || pageSize > 50,
        selector: row => (row.flagged),
        cell: row => {
          return row?.flagged ? <><span className={'fa fa-flag'}></span></> : <></>
        },
        sortable: true,
      },
      {
        name: <span className='th'>Family Members</span>,
        id: 4,
        omit: hideColumn('familyMembers') || pageSize > 50,
        selector: row => row.title,
        cell: row => {
          return <>{<FamilyMembers row={row}/>}</>
        },
        sortable: false,
      },
      {
        name: <span className='th'>Action</span>,
        id: 5,
        right: true,
        selector: row => row.guid,
        cell: row => {
          return viewClientFn(row);
        },
        sortable: false,
      }
    ]

    setColumns(_columns);
  }, [pageSize]);

  const viewClientFn = (row) => {
    let link = '/client/' + row.guid;
    return <MDButton variant="gradient" color="info" onClick={() => {
      props.action(row);
    }} size="small">{props?.actionLabel || 'View'}</MDButton>
  }

  const handleSort = (column, sortDirection) => {

    setSortOrder(column.id);
    setSortDir(sortDirection);
    setCookie('CUSTOMERS_SORT', column.id);
    setCookie('CUSTOMERS_SORT_DIR', sortDirection);

    setRender(render + 1);

  };

  const handlePageChange = (selector, page) => {
    setStartPage(selector - 1);
    setRender(render + 1);
    setSelectedRows([]);
    setToggledClearRows(!toggledClearRows);
  };

  const handleRowsPerPageChange = (selector, page) => {
    setStartPage(0);
    setPageSize(selector)
    setRender(render + 1);
    setLoading(true);
    setSelectedRows([]);
    setToggledClearRows(!toggledClearRows);
    setCookie('CUSTOMERS_ROW', selector);
  };

  const getSearchIndex = () => {
    return searchIndex;
  }

  const searchCustomersFn = async () => {
    const searchParams = {
      sortDir: sortDir,
      searchCriteria: searchCriteria,
      sortOrder: sortOrder,
      pageSize: (props?.embedded || props?.fromEvent) ? 50 : pageSize,
      startPage: startPage,
      fromEventSearch: props?.fromEvent || false,
      searchDeleted: searchDeleted,
      memberFilter: membershipTabActive
    }

    let idx = searchIndex + 1;
    setSearchIndex(idx);

    let result = await searchCustomers(searchParams, idx);

    setTmpResults(result);

  };

  useEffect(() => {
    setLoading(true);
    setSelectedRows([]);
    setToggledClearRows(!toggledClearRows);
    setRender(render + 1);
  }, [membershipTabActive])

  useEffect(() => {
    const timeOutId = setTimeout(() =>
      searchCustomersFn(), firstLoad ? 1 : 500);
    return () => clearTimeout(timeOutId);
  }, [searchCriteria]);


  const handleSearchChange = (e) => {
    setLoading(true);
    setSearchCriteria(e.target.value);
  }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  useEffect(() => {
    if (render === 0) {
      return;
    }
    searchCustomersFn();
  }, [render]);


  const [emailTemplates, setEmailTemplates] = useState([]);

  const getCompanyTemplates = async () => {
    getCommunicationTemplates().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEmailTemplates(result);
      }
    });
  }
  useEffect(() => {
    getCompanyTemplates();
  }, [])

  const [composeEmail, setComposeEmail] = useState(false);

  const [emailTemplate, setEmailTemplate] = useState(null);
  const startComposeEmail = (template) => {
    setEmailTemplate(template);
    setComposeEmail(true);
  }

  return (
    <>
      {props?.embedded &&
        <Grid container>
          <Grid item xs={12} sm={canAddCustomer ? 9 : 12}>
            <MDInput type="text"
                     variant="outlined"
                     value={searchCriteria || ''}
                     onChange={handleSearchChange}
                     className="form-control mb-2" id="searchCriteria" aria-describedby="searchCriteria"
                     label="Search Customers"/>
          </Grid>
          {canAddCustomer && <Grid item xs={12} sm={3}>
            <MDButton className={'pull-right'} size={'medium'}
                      color="info"
                      onClick={()=>{
                        setManageCustomerKey(manageCustomerKey + 1);
                        setAddCustomer(!addCustomer)
                      }}
                      className={'pull-right'}>Add Customer</MDButton>
          </Grid>}

        </Grid>

      }
      {!!!props?.embedded && <MDBox pt={3} px={3}>
        <Grid container spacing={3} direction="row-reverse">

          <Grid item xs={12} sm={6}>

            <Grid container direction="row-reverse">
              <Grid item xs={8}>
                <MDInput type="text"
                         variant="outlined"
                         value={searchCriteria || ''}
                         onChange={handleSearchChange}
                         className="form-control mb-2" id="searchCriteria" aria-describedby="searchCriteria"
                         label="Search Customers"/>
              </Grid>
            </Grid>
            <div className={'form-switch d-block text-end'}>
              <input type="checkbox"
                     role={'switch'}
                     id="searchDeleted"
                     className={'form-check-input mr-2'}
                     name="searchDeleted"
                     checked={searchDeleted}
                     onChange={(e) => {
                       setSearchDeleted(!searchDeleted);
                       setRender(render + 1);
                     }}/>
              <label className={'form-check-label'} htmlFor="searchDeleted">
                &nbsp;Search Archived
              </label>
            </div>

            <Row>
              <Col xs={12}>

                <ButtonGroup className={'my-2 pull-right'}
                             variant="outlined"
                             size="small"
                             aria-label="Filter Memberships">

                  <Button
                    size="small"
                    key={'all'}
                    style={{
                      color: membershipTabActive === 'all' ? '#fff' : '#111',
                      background: membershipTabActive === 'all' ? '#111' : '#fff',
                      borderColor: '#111'
                    }}
                    onClick={(e) => {
                      setMembershipTabActive('all')
                    }}>
                    All Customers
                  </Button>

                  <Button
                    size="small"
                    key={'active'}
                    style={{
                      color: membershipTabActive === 'active' ? '#fff' : '#111',
                      background: membershipTabActive === 'active' ? '#111' : '#fff',
                      borderColor: '#111'
                    }}
                    onClick={(e) => {
                      setMembershipTabActive('active')
                    }}>
                    Active Members
                  </Button>

                  <Button
                    size="small"
                    key={'exclude'}
                    style={{
                      color: membershipTabActive === 'exclude' ? '#fff' : '#111',
                      background: membershipTabActive === 'exclude' ? '#111' : '#fff',
                      borderColor: '#111'
                    }}
                    onClick={(e) => {
                      setMembershipTabActive('exclude')
                    }}>
                    Non-Members
                  </Button>

                </ButtonGroup>
              </Col>
            </Row>

          </Grid>

          <Grid item xs={12} sm={6} alignItems={'left'}>
            {smtpEnabled &&
              <>
                <MDButton
                  variant="outlined"
                  color="secondary"
                  size="small"
                  disabled={selectedRows?.length <= 0}
                  id="search-customers-compose-email-button"
                  aria-controls={open ? 'demo-positioned-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                >
                  <Icon>email</Icon>&nbsp;Compose Email
                </MDButton>
                <Menu
                  id="demo-positioned-menu"
                  aria-labelledby="demo-positioned-button"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  <MenuItem onClick={() => {
                    startComposeEmail({
                      emailSubject: '',
                      emailBody: ''
                    });
                    handleClose();
                  }}>Blank Email</MenuItem>
                  {emailTemplates?.map((t, idx) => {
                    return (<MenuItem key={idx} onClick={() => {
                      startComposeEmail(t);
                      handleClose();
                    }}>{t.templateName}</MenuItem>)
                  })
                  }
                </Menu>
              </>
            }


          </Grid>


        </Grid>
      </MDBox>}
      <MDBox py={1}>

        {firstLoad && <>
          <Loading/>
        </>
        }

        {!firstLoad && columns?.length > 0 && <DataTable
          disabled={loading}
          striped
          progressComponent={<MDTypography variant={'p'} className={'cursor-default'}
                                           fontWeight={'light'}><Loading/></MDTypography>}
          columns={columns}
          keyField={'guid'}
          data={searchResults}
          onSort={handleSort}
          sortServer
          selectableRows={!props?.embedded && smtpEnabled}
          onSelectedRowsChange={handleRowSelected}
          clearSelectedRows={toggledClearRows}
          highlightOnHover
          progressPending={loading}
          pagination
          paginationServer
          paginationPerPage={pageSize}
          paginationComponent={props?.embedded ? BootyPagination : ExtendedBootyPagination}
          paginationTotalRows={totalRecords}
          totalFiltered={totalFiltered}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          defaultSortFieldId={getCookie('CUSTOMERS_SORT') || 1}
          defaultSortAsc={getCookie('CUSTOMERS_SORT_DIR') === 'desc' ? false : true}
          paginationComponentOptions={PaginationOptions}
        />}

      </MDBox>


      {composeEmail && <ComposeEmailModal show={composeEmail}
                                          emailTemplate={emailTemplate}
                                          recipients={selectedRows}
                                          saving={false}
                                          handleClose={() => {
                                            setComposeEmail(false);
                                          }} handleSave={() => {
        let _context = {...context};
        _context.toast = {
          message: 'Email Sent!',
          type: 'success'
        }
        setContext({..._context});
        setComposeEmail(false);
      }}/>}

      <ManageClientModal key={manageCustomerKey}
        customer={null}
        show={addCustomer}
        saving={savingCustomer}
        handleSaveCustomer={handleSaveCustomer}
        handleClose={()=>{
          setAddCustomer(false)
        }}/>
    </>
  );
}